/** Browser localStorage helpers — SSR-safe (no-op when `window` is missing). */

function canUseStorage(): boolean {
	return typeof window !== "undefined" && typeof window.localStorage !== "undefined"
}

export function readJSON<T>(key: string): T | null {
	if (!canUseStorage()) return null
	try {
		const raw = window.localStorage.getItem(key)
		if (raw == null) return null
		return JSON.parse(raw) as T
	} catch {
		return null
	}
}

export function writeJSON(key: string, value: unknown): void {
	if (!canUseStorage()) return
	try {
		window.localStorage.setItem(key, JSON.stringify(value))
	} catch (e) {
		console.warn("localStorage.setItem failed", key, e)
	}
}

export function removeLocalStorageKey(key: string): void {
	if (!canUseStorage()) return
	try {
		window.localStorage.removeItem(key)
	} catch (e) {
		console.warn("localStorage.removeItem failed", key, e)
	}
}

/** Keys starting with `prefix` (for future sweeps / migrations). */
export function keysWithPrefix(prefix: string): string[] {
	if (!canUseStorage()) return []
	try {
		const out: string[] = []
		for (let i = 0; i < window.localStorage.length; i += 1) {
			const k = window.localStorage.key(i)
			if (k != null && k.startsWith(prefix)) out.push(k)
		}
		return out
	} catch {
		return []
	}
}
